import React, { useState } from 'react';

// components
import ChartInfoButton from 'components/charts/chartInfoButton/chartInfoButton';
import ChartResetButton from 'components/charts/chartResetButton/chartResetButton';
import ChartTooltip from 'components/charts/chartTooltip/chartTooltip';
import DatasetComboHealth from 'components/charts/datasetComboHealth/datasetComboHealth';
import IWPSlider from 'components/charts/slider/slider';
import { ChartComboItem } from 'components/charts/chartCombo/chartCombo';
import LineChartHealth from 'components/charts/lineChartHealth/lineChartHealth';
import ChartActionsMobile from 'components/charts/chartActionsMobile/chartActionsMobile';

//utils
import chartsUtils, { DataFile } from 'utils/charts.utils';

import { isArray } from 'lodash';
import ChartLegend from 'components/charts/chartLegend/chartLegend';

interface Props {
  dataFiles: DataFile[];
  titlePrefix: string;
}

const LineChartHealthWrapper = (props: Props) => {
  const [chartRef, setChartRef] = useState<any>();
  const [noData, setNoData] = useState<boolean>(false);

  const defaultLocations = ['ch'];
  const [selectedLocations, setSelectedLocations] = useState<Array<string>>(defaultLocations);

  const incomeGroups = [
    { text: 'Unterste Einkommen', value: '0' },
    { text: 'Unterer Mittelstand', value: '1' },
    { text: 'Oberer Mittelstand', value: '2' },
    { text: 'Oberste Einkommen', value: '3' },
  ];

  const defaultIncomeGroup = incomeGroups[0];
  const [incomeGroup, setIncomeGroup] = useState<ChartComboItem>(defaultIncomeGroup);

  const dataFile = props.dataFiles[parseInt(incomeGroup.value)];

  const defaultMinYear = chartsUtils.getMinYearForData(dataFile);
  const defaultMaxYear = chartsUtils.getMaxYearForData(dataFile);
  const [yearRange, setYearRange] = useState<Array<number>>([defaultMinYear, defaultMaxYear]);

  const isResetButtonDisabled =
    selectedLocations.join() === defaultLocations.join() &&
    incomeGroup.value === defaultIncomeGroup.value &&
    yearRange[0] === defaultMinYear &&
    yearRange[1] === defaultMaxYear;

  const handleDatasetChange = (value: ChartComboItem) => {
    setIncomeGroup(value);
  };

  const handleChangeYear = (value: number | number[]) => {
    if (isArray(value)) {
      setYearRange(value);
    }
  };

  const handleReset = () => {
    setIncomeGroup(incomeGroups[0]);
    setSelectedLocations(['ch']);
    setYearRange([chartsUtils.getMinYearForData(dataFile), chartsUtils.getMaxYearForData(dataFile)]);
  };

  const handleNoData = () => {
    setNoData(true);
    //setYear((year) => getNoDataNextYear(year));
  };

  const handleCallback = (chartRef: any) => {
    setChartRef(chartRef);
  };

  const handleSelectedLocation = (name: string) => {
    setSelectedLocations((selectedLocations) => [...selectedLocations, name]);
  };
  const handleUnSelectedLocation = (name: string) => {
    setSelectedLocations((selectedLocations) => selectedLocations.filter((s) => s !== name));
  };

  const handleExport = () => {
    if (chartRef) {
      chartRef.current.chart.exportChartLocal();
    }
  };

  return (
    <div className="chart2">
      <div className="chartfilters-wrapper flex flex-wrap gap-x-12 gap-y-4">
        <div className="min-w-[150px] max-w-[200px] flex-1">
          <DatasetComboHealth options={incomeGroups} value={incomeGroup} onChange={handleDatasetChange}></DatasetComboHealth>
        </div>
        <div className="min-w-[200px] max-w-[300px] flex-1">
          <IWPSlider
            range={true}
            min={chartsUtils.getMinYearForData(dataFile)}
            max={chartsUtils.getMaxYearForData(dataFile)}
            onChange={handleChangeYear}
            value={yearRange}
          />
          <ChartTooltip
            show={noData}
            text={`Sie haben ein Jahr ausgewählt, für das keine Daten verfügbar sind. Ihnen wird das nächsthöhere Jahr angezeigt. Bitte beachten Sie, dass vor ${yearRange[0]} die Steuergrundlage nur zweijährlich bemessen wurde und die Daten dadurch auch nur zweijährlich verfügbar sind.`}
          />
        </div>
        <div className="chartfilters-actions ml-auto">
          <div className="grid-row">
            <div className="grid-cell">
              <ChartResetButton onClick={handleReset} disabled={isResetButtonDisabled} />
            </div>
            <div className="grid-cell">
              <ChartInfoButton text="Geben Sie an, ob Sie sich für den Einkommensanteil vor oder nach Steuern interessieren und wählen Sie rechts aus, welches Jahr Sie sich anschauen möchten. Wenn Sie die generierte Grafik herunterladen möchten, klicken Sie bitte auf das Pfeilsymbol links." />
            </div>
          </div>
        </div>
      </div>
      <div>
        <LineChartHealth
          dataFile={dataFile}
          yearRange={yearRange}
          title={`${props.titlePrefix} ${incomeGroup.text} ${yearRange[0]} - ${yearRange[1]}`}
          selectedLocations={selectedLocations}
          onNoData={handleNoData}
          onCallback={handleCallback}
          options={{
            tooltip: {
              headerLabel1: 'JAHR',
              headerLabel2: 'UMVERTEILUNG (in CHF pro Kopf)',
            },
            yAxis: {
              title: 'Umverteilung (in CHF pro Kopf)',
            },
          }}
          onSelectedLocation={handleSelectedLocation}
          onUnSelectedLocation={handleUnSelectedLocation}
        />
      </div>
      <ChartActionsMobile onExport={handleExport} onReset={handleReset} resetButtonDisabled={isResetButtonDisabled}></ChartActionsMobile>
      <ChartLegend onExport={handleExport} />
    </div>
  );
};

export default LineChartHealthWrapper;
